import React from "react";

const Contact = () => {
  return (
    <div style={{ color: "#fff" }}>
      <h3>Contact</h3>
      <p>
        I am a skilled and highly motivated software developer with 3+ years of
        experience (on self project) in building and delivering various
        websites. I have a strong background in ReactJS, NodeJS, C++, and Java
        and have a passion for delivering high-quality software solutions. I
        have worked on several projects, including an E-commerce website, an
        Instagram clone, and a coaching management system, where I have
        demonstrated my ability to analyze requirements, design and implement
        features, and deliver functional and reliable applications. As a fresher
        for a job, I bring a fresh perspective and a wealth of knowledge and
        skills to any development team. My experience has equipped me with the
        necessary skills to work in a fast-paced environment and meet tight
        deadlines. I am eager to continue my career as a developer and am
        confident that I can make a positive impact in any development role.
        <br />
        <br />
        prem.com0011@gmail.com
      </p>
    </div>
  );
};

export default Contact;
